import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["attachmentPreviewLink"];

  remove() {
    if (window.confirm("削除しますか？")) {
      this.element.remove();
    }
  }

  previewAttachment(event) {
    const file = event.target.files[0];

    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
    }

    if (file) {
      this.currentObjectUrl = URL.createObjectURL(file);
      this.attachmentPreviewLinkTarget.href = this.currentObjectUrl;
      this.attachmentPreviewLinkTarget.classList.remove("is-hidden");
    } else {
      this.attachmentPreviewLinkTarget.classList.add("is-hidden");
    }
  }
}
